// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { BehaviorSubject, Observable } from 'rxjs';

// --- HS Code
import { Constants } from '../../models';
import { Claims } from './account/claims';
import { OidcService } from './account/oidc.service';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class FeaturesService {

  private _openPacksFeatureState$: BehaviorSubject<string> = new BehaviorSubject<string>(Constants.FEATURE_OFF);
  get openPacksFeatureState$(): Observable<string> {
    return this._openPacksFeatureState$.asObservable();
  }

  private _selfRegistrationFeatureState$: BehaviorSubject<string> = new BehaviorSubject<string>(Constants.FEATURE_OFF);
  get selfRegistrationFeatureStatus$(): Observable<string> {
    return this._selfRegistrationFeatureState$.asObservable();
  }

  constructor(
    private _envService: EnvService,
    private _oidcService: OidcService,
  ) {
    this._loadFeatures();
  }

  private _loadFeatures(): void {
    this._oidcService.claims$.subscribe((claims: Claims) => {
      this._setOpenPacksFeatureState(claims);
      this._setSelfRegistrationFeatureState(claims);
    });
  }

  private _setOpenPacksFeatureState(claims: Claims) {
    if (this._envService.openPacks.toLowerCase() === Constants.FEATURE_OFF) {
      this._openPacksFeatureState$.next(Constants.FEATURE_OFF);
      return;
    }

    if (this._envService.openPacks.toLocaleLowerCase() !== Constants.FEATURE_ON) {
      const claimName = this._envService.openPacks.toLowerCase();

      if (!claims.hasClaim(claimName) || !claims.is(claimName)) {
        this._openPacksFeatureState$.next(Constants.FEATURE_OFF);
        return;
      }
    }

    this._openPacksFeatureState$.next(Constants.FEATURE_ON);
  }

  private _setSelfRegistrationFeatureState(claims: Claims): void {
    if (this._envService.selfRegistration.toLowerCase() === Constants.FEATURE_OFF) {
      this._selfRegistrationFeatureState$.next(Constants.FEATURE_OFF);
      return;
    }

    if (this._envService.selfRegistration.toLocaleLowerCase() !== Constants.FEATURE_ON) {
      const claimName = this._envService.selfRegistration.toLowerCase();

      if (!claims.hasClaim(claimName) || !claims.is(claimName)) {
        this._selfRegistrationFeatureState$.next(Constants.FEATURE_OFF);
        return;
      }
    }

    if (!claims.hasClaim(Constants.CLAIMS_COMPANY_ID)) {
      this._selfRegistrationFeatureState$.next(Constants.FEATURE_OFF);
      return;
    }

    const companyId = claims.getClaimValue(Constants.CLAIMS_COMPANY_ID);
    if (companyId.toUpperCase().indexOf(Constants.CLAIMS_COMPANY_BENCH) < 0) {
      this._selfRegistrationFeatureState$.next(Constants.FEATURE_ON);
      return;
    }

    this._selfRegistrationFeatureState$.next(Constants.FEATURE_OFF);
  }
}
